/**************************************************
 * Nombre:       Detalle_Especificaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import ic_agua from '../../../Recursos/ic_agua_negro.svg'
import ic_almoadas from '../../../Recursos/ic_almoadas.svg'
import Tarjeta_Detalle_Especificaciones from "../../Tarjetas/Tarjeta_Detalle_Especificaciones";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Detalle_Especificaciones = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Tarjeta_Detalle_Especificaciones item={agua}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                            <Tarjeta_Detalle_Especificaciones item={almoadas}/>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Detalle_Especificaciones


const agua = {
    img: ic_agua,
    largo: 40,
    nombre: 'El agua tratada con las tecnologías de Nipponflex',
    items: [
        {
            nombre: 'Hidratación a Nivel Celular',
            descripcion: 'Gracias a la tecnología de magnetoterapia e infrarrojo lejano, las moléculas de agua se reorganizan en grupos más pequeños (clusters). Esto permite que el agua penetre con mayor facilidad en las células, logrando una hidratación mucho más profunda y eficaz que el agua convencional.'
        },
        {
            nombre: 'Equilibrio del pH (Agua Alcalina)',
            descripcion: 'El sistema ayuda a elevar el pH del agua, convirtiéndola en alcalina. Un cuerpo con un pH equilibrado es menos propenso a desarrollar enfermedades inflamatorias y ayuda a neutralizar la acidez excesiva provocada por la mala alimentación y el estrés.',
        },
        {
            nombre: 'Potente Acción Antioxidante',
            descripcion: 'El agua tratada ayuda a combatir los radicales libres, que son los responsables del envejecimiento prematuro y el deterioro celular. Al actuar como un antioxidante natural, protege los tejidos y mejora la apariencia de la piel.',
        },
        {
            nombre: 'Mejora de la Circulación y Energía',
            descripcion: 'Una mejor hidratación facilita el transporte de nutrientes y oxígeno a través de la sangre. Esto se traduce en: Una mejor digestión y tránsito intestinal. Mayor claridad mental y reducción de la fatiga. Ayuda en la eliminación de toxinas (efecto detox).',
        },

    ]
}

const almoadas = {
    img: ic_almoadas,
    largo: 50,
    nombre: 'Almohadas de Nipponflex diseñadas para mejorar la calidad del descanso',
    items: [
        {
            nombre: 'Tecnologías de Bienestar',
            descripcion: 'A diferencia de una almohada convencional, estas incorporan elementos activos: Magnetoterapia: Poseen imanes que crean un campo magnético constante, lo cual puede ayudar a mejorar la circulación sanguínea y reducir la tensión muscular. Infrarrojo Lejano (FIR): Utilizan pastillas de biocerámica que emiten ondas de calor sutiles para ayudar a la regeneración celular y la eliminación de toxinas.'
        },
        {
            nombre: 'Soporte y Ergonomía',
            descripcion: 'Alineación de la Columna: Están diseñadas para mantener la curvatura natural del cuello (columna cervical), evitando dolores de espalda y cuello al despertar. Densidad Balanceada: Suelen utilizar materiales que no se deforman fácilmente, ofreciendo un soporte firme pero cómodo.'
        },
        {
            nombre: 'Higiene',
            descripcion: 'Tejido Especial: Muchas incluyen tratamientos antibacterianos, antiácaros y antihongos, lo que las hace ideales para personas con alergias'
        },
        {
            nombre: 'Temperatura',
            descripcion: 'Regulación Térmica: La estructura de sus materiales permite una mejor ventilación, evitando que la almohada acumule calor excesivo durante la noche.'
        }

    ]
}